/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/
import ProjectDetail from "@/components/controllers/projects/project_detail/ProjectDetail";
import { AuthStates, getAuthState } from "@/lib/auth/auth_state";
import { projectsSelectors, useFetchProjectsQuery } from "@/lib/datastore/slices/projects";
import { createFileRoute } from "@tanstack/react-router";
import { NotFoundError } from "@/components/controllers/errors/NotFoundError";
import { useTranslation } from "@/i18n/client_hook";
import { defaultNS } from "@/i18n/settings";
import type { UnauthVersionURI } from "@/components/controllers/auth/ValidateAccessToken";
import React from "react";

//Unauthenticated version of this page
export const unauthenticatedRedirect:UnauthVersionURI = (location):string|undefined => {
  const path_parts = location.pathname.split("/");
  if (path_parts.length == 3 && path_parts[1] == "project") {
    return `/project/${path_parts[2]}/public?` + (new URLSearchParams(location.search)).toString()
  }
  
  return undefined;
}

export const Route = createFileRoute("/_authenticated/project/$project_id")({
  component: RouteComponent
})

function RouteComponent() {
  const { t } = useTranslation(defaultNS);
  const { project_id } = Route.useParams();
  const { project } = useFetchProjectsQuery(
    { org_id: getAuthState(AuthStates.activeOrgID)!, project_ids: [project_id] }, {
    selectFromResult: ({ data, ...other }) => ({
      ...other,
      project: data ? projectsSelectors.selectById(data, project_id) : null
    })
  }
  )


  return <React.Fragment>
    {project == null && <NotFoundError />}
    {project && <ProjectDetail project={project} />}
  </React.Fragment>;
}